import React, { useState, useEffect } from "react";
// import { Snackbar, Button } from "@material-ui/core";
import * as serviceWorker from "../serviceWorker";

const ServiceWorkerWrapper = () => {
  const [, setShowReload] = useState(false);

  const onSWUpdate = (_registration) => {
    setShowReload(true);
  };

  useEffect(() => {
    // On iOS, unregister any existing SW so we don't serve stale cache (blank page after deploy).
    if (serviceWorker.isIOS() && "serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((reg) => reg.unregister());
      });
    }
    serviceWorker.register({ onUpdate: onSWUpdate });
  }, []);

  return (
    <></>
    // <Snackbar
    //   open={showReload}
    //   message="A new version is available!"
    //   onClick={reloadPage}
    //   anchorOrigin={{ vertical: "top", horizontal: "center" }}
    //   action={
    //     <Button color="inherit" size="small" onClick={reloadPage}>
    //       Reload
    //     </Button>
    //   }
    // />
  );
};

export default ServiceWorkerWrapper;
